import Vue from "vue"
import VueI18n from "vue-i18n"
import router from "@/config/router"

Vue.use(VueI18n)

/* EN - ENGLISH */
import en_global from "../languages/en"
import en_dashboard from "../modules/dashboard/language/en"
import en_settings from "../modules/settings/language/en"
import en_auth from "../modules/auth/language/en"
import en_users from "../modules/users/language/en"
import en_roles from "../modules/roles/language/en"
import en_permissions from "../modules/permissions/language/en"
import en_organisations from "../modules/organisations/language/en"
import en_coursetemplates from "../modules/coursetemplates/language/en"
import en_logs from "../modules/logs/language/en"
import en_queues from "../modules/queues/language/en"
import en_classes from "../modules/classes/language/en"
import en_coursetypegroups from "../modules/coursetypegroups/language/en"
import en_coursetypes from "../modules/coursetypes/language/en"
import en_courses from "../modules/courses/language/en"
import en_tasks from "../modules/tasks/language/en"
import en_drivingtests from "../modules/drivingtests/language/en"
import en_addresses from "../modules/addresses/language/en"
import en_classrooms from "../modules/classrooms/language/en"
import en_frontend from "../modules/frontend/language/en"
import en_enrolments from "../modules/enrolments/language/en"
import en_participants from "../modules/participants/language/en"
import en_attendees from "../modules/attendees/language/en"
import en_calendar from "../modules/calendar/language/en"
import en_moduletemplates from "../modules/moduletemplates/language/en"
import en_moduleoptions from "../modules/moduleoptions/language/en"
import en_moduleoptioncoursetypes from "../modules/moduleoptioncoursetypes/language/en"
import en_certificates from "../modules/certificates/language/en"
import en_customergroups from "../modules/customergroups/language/en"
import en_checkin from "../modules/checkin/language/en"
import en_notificationtemplate from "../modules/notificationtemplates/language/en"
import en_studentgroups from "../modules/studentgroups/language/en"
import en_educationprograms from "../modules/educationprograms/language/en"
import en_reports from "../modules/reports/language/en"
import en_integrations from "../modules/integrations/language/en"
import en_passports from "../modules/passports/language/en"
import en_notificationlogs from "../modules/notificationlogs/language/en"
import en_data from "../modules/data/language/en"
import en_notification from "../modules/notifications/language/en"
import en_changelog from "../modules/changelog/language/en"
import en_equipments from "../modules/equipments/language/en"
import en_equipmentcategories from "../modules/equipmentcategories/language/en"
import en_equipmentmanufacturers from "../modules/equipmentmanufacturers/language/en"
import en_equipmentmodels from "../modules/equipmentmodels/language/en"
import en_equipmenttypes from "../modules/equipmenttypes/language/en"
import en_checklist from "../modules/checklist/language/en"
import en_checklistapi from "../mixins/components/checklist/languages/en"
import en_checklisttemplate from "../modules/checklisttemplate/language/en"
import en_modules from "../modules/modules/language/en"

/* NO - NORWEGIAN */
import no_global from "../languages/no"
import no_dashboard from "../modules/dashboard/language/no"
import no_settings from "../modules/settings/language/no"
import no_auth from "../modules/auth/language/no"
import no_users from "../modules/users/language/no"
import no_roles from "../modules/roles/language/no"
import no_permissions from "../modules/permissions/language/no"
import no_organisations from "../modules/organisations/language/no"
import no_coursetemplates from "../modules/coursetemplates/language/no"
import no_logs from "../modules/logs/language/no"
import no_queues from "../modules/queues/language/no"
import no_classes from "../modules/classes/language/no"
import no_coursetypegroups from "../modules/coursetypegroups/language/no"
import no_coursetypes from "../modules/coursetypes/language/no"
import no_courses from "../modules/courses/language/no"
import no_tasks from "../modules/tasks/language/no"
import no_drivingtests from "../modules/drivingtests/language/no"
import no_addresses from "../modules/addresses/language/no"
import no_classrooms from "../modules/classrooms/language/no"
import no_frontend from "../modules/frontend/language/no"
import no_enrolments from "../modules/enrolments/language/no"
import no_participants from "../modules/participants/language/no"
import no_attendees from "../modules/attendees/language/no"
import no_calendar from "../modules/calendar/language/no"
import no_moduletemplates from "../modules/moduletemplates/language/no"
import no_moduleoptions from "../modules/moduleoptions/language/no"
import no_moduleoptioncoursetypes from "../modules/moduleoptioncoursetypes/language/no"
import no_certificates from "../modules/certificates/language/no"
import no_customergroups from "../modules/customergroups/language/no"
import no_checkin from "../modules/checkin/language/no"
import no_notificationtemplate from "../modules/notificationtemplates/language/no"
import no_studentgroups from "../modules/studentgroups/language/no"
import no_educationprograms from "../modules/educationprograms/language/no"
import no_reports from "../modules/reports/language/no"
import no_integrations from "../modules/integrations/language/no"
import no_passports from "../modules/passports/language/no"
import no_notificationlogs from "../modules/notificationlogs/language/no"
import no_data from "../modules/data/language/no"
import no_notification from "../modules/notifications/language/no"
import no_changelog from "../modules/changelog/language/no"
import no_equipments from "../modules/equipments/language/no"
import no_equipmentcategories from "../modules/equipmentcategories/language/no"
import no_equipmentmanufacturers from "../modules/equipmentmanufacturers/language/no"
import no_equipmentmodels from "../modules/equipmentmodels/language/no"
import no_equipmenttypes from "../modules/equipmenttypes/language/no"
import no_checklist from "../modules/checklist/language/no"
import no_checklistapi from "../mixins/components/checklist/languages/no"
import no_checklisttemplate from "../modules/checklisttemplate/language/no"
import no_modules from "../modules/modules/language/no"

/* NN - NYNORSK */
import nn_global from "../languages/nn"
import nn_dashboard from "../modules/dashboard/language/nn"
import nn_settings from "../modules/settings/language/nn"
import nn_auth from "../modules/auth/language/nn"
import nn_users from "../modules/users/language/nn"
import nn_roles from "../modules/roles/language/nn"
import nn_permissions from "../modules/permissions/language/nn"
import nn_organisations from "../modules/organisations/language/nn"
import nn_coursetemplates from "../modules/coursetemplates/language/nn"
import nn_logs from "../modules/logs/language/nn"
import nn_queues from "../modules/queues/language/nn"
import nn_classes from "../modules/classes/language/nn"
import nn_coursetypegroups from "../modules/coursetypegroups/language/nn"
import nn_coursetypes from "../modules/coursetypes/language/nn"
import nn_courses from "../modules/courses/language/nn"
import nn_tasks from "../modules/tasks/language/nn"
import nn_drivingtests from "../modules/drivingtests/language/nn"
import nn_addresses from "../modules/addresses/language/nn"
import nn_classrooms from "../modules/classrooms/language/nn"
import nn_frontend from "../modules/frontend/language/nn"
import nn_enrolments from "../modules/enrolments/language/nn"
import nn_participants from "../modules/participants/language/nn"
import nn_attendees from "../modules/attendees/language/nn"
import nn_calendar from "../modules/calendar/language/nn"
import nn_moduletemplates from "../modules/moduletemplates/language/nn"
import nn_moduleoptions from "../modules/moduleoptions/language/nn"
import nn_moduleoptioncoursetypes from "../modules/moduleoptioncoursetypes/language/nn"
import nn_certificates from "../modules/certificates/language/nn"
import nn_customergroups from "../modules/customergroups/language/nn"
import nn_checkin from "../modules/checkin/language/nn"
import nn_notificationtemplate from "../modules/notificationtemplates/language/nn"
import nn_studentgroups from "../modules/studentgroups/language/nn"
import nn_educationprograms from "../modules/educationprograms/language/nn"
import nn_reports from "../modules/reports/language/nn"
import nn_integrations from "../modules/integrations/language/nn"
import nn_passports from "../modules/passports/language/nn"
import nn_notificationlogs from "../modules/notificationlogs/language/nn"
import nn_data from "../modules/data/language/nn"
import nn_notification from "../modules/notifications/language/nn"
import nn_changelog from "../modules/changelog/language/nn"
import nn_equipments from "../modules/equipments/language/nn"
import nn_equipmentcategories from "../modules/equipmentcategories/language/nn"
import nn_equipmentmanufacturers from "../modules/equipmentmanufacturers/language/nn"
import nn_equipmentmodels from "../modules/equipmentmodels/language/nn"
import nn_equipmenttypes from "../modules/equipmenttypes/language/nn"
import nn_checklist from "../modules/checklist/language/nn"
import nn_checklistapi from "../mixins/components/checklist/languages/nn"
import nn_checklisttemplate from "../modules/checklisttemplate/language/nn"
import nn_modules from "../modules/modules/language/nn"

const locales = {
  en: {
    global: en_global,
    settings: en_settings,
    dashboard: en_dashboard,
    auth: en_auth,
    users: en_users,
    roles: en_roles,
    permissions: en_permissions,
    organisations: en_organisations,
    coursetemplates: en_coursetemplates,
    logs: en_logs,
    queues: en_queues,
    classes: en_classes,
    coursetypegroups: en_coursetypegroups,
    coursetypes: en_coursetypes,
    courses: en_courses,
    tasks: en_tasks,
    drivingtests: en_drivingtests,
    addresses: en_addresses,
    classrooms: en_classrooms,
    fe: en_frontend,
    enrolments: en_enrolments,
    participants: en_participants,
    attendees: en_attendees,
    calendar: en_calendar,
    moduletemplates: en_moduletemplates,
    moduleoptions: en_moduleoptions,
    moduleoptioncoursetypes: en_moduleoptioncoursetypes,
    certificates: en_certificates,
    customergroups: en_customergroups,
    checkin: en_checkin,
    notificationtemplates: en_notificationtemplate,
    studentgroups: en_studentgroups,
    educationprograms: en_educationprograms,
    reports: en_reports,
    integrations: en_integrations,
    passports: en_passports,
    notificationlogs: en_notificationlogs,
    data: en_data,
    notifications: en_notification,
    changelog: en_changelog,
    equipments: en_equipments,
    equipmentcategories: en_equipmentcategories,
    equipmenttypes: en_equipmenttypes,
    equipmentmanufacturers: en_equipmentmanufacturers,
    equipmentmodels: en_equipmentmodels,
    checklist: en_checklist,
    checklistapi: en_checklistapi,
    checklisttemplate: en_checklisttemplate,
    modules: en_modules,
  },

  no: {
    global: no_global,
    settings: no_settings,
    dashboard: no_dashboard,
    auth: no_auth,
    users: no_users,
    roles: no_roles,
    permissions: no_permissions,
    organisations: no_organisations,
    coursetemplates: no_coursetemplates,
    logs: no_logs,
    queues: no_queues,
    classes: no_classes,
    coursetypegroups: no_coursetypegroups,
    coursetypes: no_coursetypes,
    courses: no_courses,
    tasks: no_tasks,
    drivingtests: no_drivingtests,
    addresses: no_addresses,
    classrooms: no_classrooms,
    fe: no_frontend,
    enrolments: no_enrolments,
    participants: no_participants,
    attendees: no_attendees,
    calendar: no_calendar,
    moduletemplates: no_moduletemplates,
    moduleoptions: no_moduleoptions,
    moduleoptioncoursetypes: no_moduleoptioncoursetypes,
    certificates: no_certificates,
    customergroups: no_customergroups,
    checkin: no_checkin,
    notificationtemplates: no_notificationtemplate,
    studentgroups: no_studentgroups,
    educationprograms: no_educationprograms,
    reports: no_reports,
    integrations: no_integrations,
    passports: no_passports,
    notificationlogs: no_notificationlogs,
    data: no_data,
    notifications: no_notification,
    changelog: no_changelog,
    equipments: no_equipments,
    equipmentcategories: no_equipmentcategories,
    equipmenttypes: no_equipmenttypes,
    equipmentmanufacturers: no_equipmentmanufacturers,
    equipmentmodels: no_equipmentmodels,
    checklist: no_checklist,
    checklistapi: no_checklistapi,
    checklisttemplate: no_checklisttemplate,
    modules: no_modules,
  },

  nn: {
    global: nn_global,
    settings: nn_settings,
    dashboard: nn_dashboard,
    auth: nn_auth,
    users: nn_users,
    roles: nn_roles,
    permissions: nn_permissions,
    organisations: nn_organisations,
    coursetemplates: nn_coursetemplates,
    logs: nn_logs,
    queues: nn_queues,
    classes: nn_classes,
    coursetypegroups: nn_coursetypegroups,
    coursetypes: nn_coursetypes,
    courses: nn_courses,
    tasks: nn_tasks,
    drivingtests: nn_drivingtests,
    addresses: nn_addresses,
    classrooms: nn_classrooms,
    fe: nn_frontend,
    enrolments: nn_enrolments,
    participants: nn_participants,
    attendees: nn_attendees,
    calendar: nn_calendar,
    moduletemplates: nn_moduletemplates,
    moduleoptions: nn_moduleoptions,
    moduleoptioncoursetypes: nn_moduleoptioncoursetypes,
    certificates: nn_certificates,
    customergroups: nn_customergroups,
    checkin: nn_checkin,
    notificationtemplates: nn_notificationtemplate,
    studentgroups: nn_studentgroups,
    educationprograms: nn_educationprograms,
    reports: nn_reports,
    integrations: nn_integrations,
    passports: nn_passports,
    notificationlogs: nn_notificationlogs,
    data: nn_data,
    notifications: nn_notification,
    changelog: nn_changelog,
    equipments: nn_equipments,
    equipmentcategories: nn_equipmentcategories,
    equipmenttypes: nn_equipmenttypes,
    equipmentmanufacturers: nn_equipmentmanufacturers,
    equipmentmodels: nn_equipmentmodels,
    checklist: nn_checklist,
    checklistapi: nn_checklistapi,
    checklisttemplate: nn_checklisttemplate,
    modules: nn_modules,
  }
}

let user = localStorage.getItem("__crrntUser")
let locale = "en"

if (user) {
  user = JSON.parse(user)

  if (user) {
    // HACK: IF THE SETTINGS IN THE LOCALSTORAGE IS NOT ARRAY, IT MEANS THAT THEIR SETTINGS IS NOT YET UPDATED, WILL DO FORCE LOGOUT
    if (!Array.isArray(user.settings)) {
      localStorage.removeItem("__crrntUser")
      router.push("/auth/no/login")
    } else {
      locale = user.settings.find((i) => i.key == "locale").value
    }
  }
}

export default new VueI18n({
  locale: "",
  fallbackLocale: locale,
  messages: locales,
  silentTranslationWarn: true
})
